import React, { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog, F0Select } from '@factorialco/f0-react'
import { Input } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { useComplaintStatus } from 'modules/complaints/hooks/useComplaintStatus'
import { statusLabel } from 'modules/complaints/lib/utils/complaintStatus'

interface ChangeStatusModalProps {
  isOpen: boolean
  onClose: () => void
  complaint: {
    id: string
    status: string
    identifier: string
  }
}

export const ChangeStatusModal: React.FC<ChangeStatusModalProps> = ({
  isOpen,
  onClose,
  complaint,
}) => {
  const [selectedStatus, setSelectedStatus] = useState<string>(complaint.status)
  const [isLoading, setIsLoading] = useState(false)

  const { updateComplaintStatus, getStatusOptionsForModal } = useComplaintStatus()

  const handleSave = async () => {
    if (selectedStatus === complaint.status) {
      onClose()
      return
    }

    setIsLoading(true)

    await updateComplaintStatus(complaint.id, selectedStatus)

    onClose()
    setIsLoading(false)
  }

  const statusOptions = getStatusOptionsForModal(complaint.status)

  if (statusOptions.length === 0) {
    return null
  }

  return (
    <F0Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('complaints.overview.change_status')}
      primaryAction={{
        label: isLoading ? i18n.t('common.saving') : i18n.t('common.save'),
        onClick: handleSave,
        disabled: isLoading || selectedStatus === complaint.status,
        loading: isLoading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <Box gap="s12">
        <Text.Normal size="200">
          {i18n.t('complaints.overview.complaint_number', {
            identifier: complaint.identifier,
          })}
        </Text.Normal>

        <Box gap="s12" width="full">
          <Input
            label={i18n.t('complaints.overview.existing_status')}
            value={statusLabel(complaint.status)}
            disabled
          />
          <F0Select
            label={i18n.t('complaints.overview.new_status')}
            value={selectedStatus}
            onChange={(value: string) => setSelectedStatus(value)}
            options={statusOptions}
            placeholder={i18n.t('complaints.overview.select_status')}
          />
        </Box>
      </Box>
    </F0Dialog>
  )
}
